/* Arsoa — cursor-following spotlight on rich-text headings.
   Updates --arsoa-mx / --arsoa-my (consumed by arsoa-overrides.css)
   so a crimson glow tracks the pointer across the heading text. */
(function () {
  function bind(el) {
    if (el.dataset.arsoaShine) return;
    el.dataset.arsoaShine = '1';

    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--arsoa-mx', (e.clientX - r.left).toFixed(1) + 'px');
      el.style.setProperty('--arsoa-my', (e.clientY - r.top).toFixed(1) + 'px');
    });

    function reset() {
      el.style.setProperty('--arsoa-mx', '-300px');
      el.style.setProperty('--arsoa-my', '-300px');
    }
    el.addEventListener('pointerleave', reset);
    el.addEventListener('blur', reset);
  }

  function init(root) {
    (root || document).querySelectorAll('.rich-text__heading, .rich-text__text').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-bind when sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
